export enum EPlatformNoticeAudienceType {
  AllStores = "AllStores",
  SelectedStores = "SelectedStores",
  AllCouriers = "AllCouriers",
  SelectedCouriers = "SelectedCouriers",
  AllResellers = "AllResellers",
  SelectedResellers = "SelectedResellers",
  CouriersAndResellers = "CouriersAndResellers",
  AllAudiences = "AllAudiences",
}
